import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { LanguageService } from '../../../services/i18n/language';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent implements OnInit, OnDestroy {
  readonly email = 'info@bilload.com';
  readonly phone = '+7 707 888 00 54';
  readonly phoneHref = 'tel:+77078880054';
  readonly linkedinHref = 'https://linkedin.com/company/bilload';
  readonly instagramHref = 'https://www.instagram.com/bilload.kz';
  readonly telegramHref = 'https://t.me/bilload2026';

  private subscriptions = new Subscription();

  constructor(
    private languageService: LanguageService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.languageService.getTranslations().subscribe(() => this.cdr.detectChanges())
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  t(key: string): string {
    const value = this.languageService.translate(key);
    return !value || value === key ? '' : value;
  }

  /** Логотип: к началу лендинга; с других страниц — переход на главную и сразу наверх. */
  goToTop(event: Event): void {
    this.goToPage(event, '/');
  }

  /** Переход на страницу с начала (роутер сам не сбрасывает прокрутку); на той же странице — наверх. */
  goToPage(event: Event, url: string): void {
    event.preventDefault();
    if (this.router.url.split(/[?#]/)[0] === url) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      this.router.navigateByUrl(url).then(() => window.scrollTo(0, 0));
    }
  }

  /** Прокрутка к разделу главной страницы; с других страниц — сначала переход на главную. */
  goToSection(event: Event, id: string): void {
    event.preventDefault();
    const scroll = () => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    if (this.router.url.split(/[?#]/)[0] === '/') {
      scroll();
    } else {
      this.router.navigateByUrl('/').then(() => setTimeout(scroll));
    }
  }
}
